import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export default function AuthPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    if (isClient) {
      // Redirect to the new login page for backward compatibility
      const redirect = searchParams.get('redirect')
      const redirectParam = redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''
      navigate(`/login${redirectParam}`, { replace: true })
    }
  }, [navigate, searchParams, isClient])

  if (!isClient) {
    return <div>Loading...</div>
  }

  return null // Will redirect via useEffect
}